import { type ReactNode } from 'react';
import { DropdownSelect } from '@/components/ui/dropdown-select';
import type {
  CategorySel,
  CreatorCategory,
  CreatorSex,
  CreatorStatus,
  CreatorType,
} from '@/types';
import {
  ALL,
  CAT_OPTS,
  RANK_OPTS,
  SEX_OPTS,
  STATUS_OPTS,
  parseCat,
  parseSex,
  parseStatus,
  toVal,
} from './filter-selects.helpers';

type Props = {
  category: CreatorCategory | undefined;
  creator_type: CreatorType | undefined;
  rank: number | undefined;
  status: CreatorStatus | undefined;
  sex: CreatorSex | undefined;
  onCategorySel: (v: CategorySel | undefined) => void;
  onRank: (v: number | undefined) => void;
  onStatus: (v: CreatorStatus | undefined) => void;
  onSex: (v: CreatorSex | undefined) => void;
};

function catValue(p: Props): string {
  return p.category && p.creator_type ? `${p.creator_type}:${p.category}` : ALL;
}

function PrimarySelects(p: Props): ReactNode {
  return (
    <>
      <DropdownSelect
        options={CAT_OPTS}
        value={catValue(p)}
        placeholder="Categoría"
        onChange={(v) => p.onCategorySel(parseCat(v))}
      />
      <DropdownSelect
        options={RANK_OPTS}
        value={p.rank ? String(p.rank) : ALL}
        placeholder="Followers"
        onChange={(v) => p.onRank(toVal(v) ? Number(v) : undefined)}
      />
    </>
  );
}

function SecondarySelects(
  p: Pick<Props, 'status' | 'sex' | 'onStatus' | 'onSex'>
): ReactNode {
  return (
    <>
      <DropdownSelect
        options={STATUS_OPTS}
        value={p.status ?? ALL}
        placeholder="Status"
        onChange={(v) => p.onStatus(parseStatus(v))}
      />
      <DropdownSelect
        options={SEX_OPTS}
        value={p.sex ?? ALL}
        placeholder="Género"
        onChange={(v) => p.onSex(parseSex(v))}
      />
    </>
  );
}

export function FilterSelects(p: Props): ReactNode {
  return (
    <>
      <PrimarySelects {...p} />
      <SecondarySelects
        status={p.status}
        sex={p.sex}
        onStatus={p.onStatus}
        onSex={p.onSex}
      />
    </>
  );
}
